module.exports = __webpack_public_path__ + "static/dragon-3ca2a4da6edac4d8ae0e168517256f4f.jpg";